import { componentRestResource } from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";
import { GetComponentRequest } from "./get-component/GetComponentRequest";
import { GetComponentResponse } from "./get-component/GetComponentResponse";
import { CreateComponentRequest } from "./create-component/CreateComponentRequest";
import { CreateComponentResponse } from "./create-component/CreateComponentResponse";
import { UpdateComponentRequest } from "./update-component/UpdateComponentRequest";
import { UpdateComponentResponse } from "./update-component/UpdateComponentResponse";
import { UpdateComponentAttributesRequest } from "./update-component-attributes/UpdateComponentAttributesRequest";
import { UpdateComponentAttributesResponse } from "./update-component-attributes/UpdateComponentAttributesResponse";

export const useGetComponent = () =>
  useRestResourceHook<GetComponentRequest, GetComponentResponse>((request) =>
    componentRestResource.getComponent(request),
  );

export const useCreateComponent = () =>
  useRestResourceHook<CreateComponentRequest, CreateComponentResponse>(
    (request) => componentRestResource.createComponent(request),
  );

export const useUpdateComponent = () =>
  useRestResourceHook<UpdateComponentRequest, UpdateComponentResponse>(
    (request) => componentRestResource.updateComponent(request),
  );

export const useUpdateComponentAttributes = () =>
  useRestResourceHook<
    UpdateComponentAttributesRequest,
    UpdateComponentAttributesResponse
  >((request) => componentRestResource.updateComponentAttributes(request));
